import API from '../../../helpers/api';

import { message } from '../../../utils/message';

import { loadLang } from '../../data/actions/Data';
import CLIENT from '../actionTypes';
import { setLang } from './Client';

import { AppDispatch, GetState } from '../../../types/app';
import { ClientPersonalInfoType } from '../types';

export const load = () => async (dispatch: AppDispatch) => {
  await dispatch({ type: CLIENT.PERSONAL_INFO.LOAD.REQUESTING });

  try {
    const { data } = await API.callGraphQL<{ data: ClientPersonalInfoType }>(`
      query {
        data: clientPersonalInfo {
          Name
          LastName
          Email
          EmailStatus
          Phone
          PasswordPhone
          Country
          State
          City
          ZipCode
          Address
          Lang
        }
      }
    `);

    return dispatch({
      type: CLIENT.PERSONAL_INFO.LOAD.SUCCESS,
      data,
    });
  } catch (err) {
    return dispatch({
      type: CLIENT.PERSONAL_INFO.LOAD.FAILURE,
      err: err.message,
    });
  }
};

export const loadIfNeeded =
  () => async (dispatch: AppDispatch, getState: GetState) => {
    const { ClientPersonalInfo } = getState();

    if (!ClientPersonalInfo.info) {
      return dispatch(load());
    }
    return null;
  };

export const save =
  (values: Partial<ClientPersonalInfoType>) =>
  async (dispatch: AppDispatch, getState: GetState) => {
    dispatch({ type: CLIENT.PERSONAL_INFO.SAVE.REQUESTING });

    const {
      ClientPersonalInfo: { info },
    } = getState();

    const Lang = info?.Lang;

    try {
      await API.callGraphQL(
        `
      mutation ($Phone: String, $PasswordPhone: String, $Country: String, $State: String,
          $City: String, $ZipCode: String, $Address: String, $Lang: Lang) {
        result: clientPersonalInfoSave(Phone: $Phone, PasswordPhone: $PasswordPhone,
          Country: $Country, State: $State, City: $City, ZipCode: $ZipCode, Address: $Address, Lang: $Lang)
      }
    `,
        values
      );

      dispatch({
        type: CLIENT.PERSONAL_INFO.SAVE.SUCCESS,
      });

      message.success('profile.personalInfo.success');

      if (Lang !== values.Lang) {
        dispatch(loadLang(values.Lang));
        dispatch(setLang(values.Lang));
      }

      return dispatch(load());
    } catch (err) {
      dispatch({
        type: CLIENT.PERSONAL_INFO.SAVE.FAILURE,
        err: err.message,
      });
      return message.error(err);
    }
  };
